import { Component, OnInit } from '@angular/core';
import { Config } from '../../config/config';
import { LocalstorageService } from '../../service/localstorage.service';
import { RestDataService } from '../../service/rest-data.service';
import { SharedDataService } from '../../service/shared-data.service';
import { StaticDataService } from '../../service/static-data.service';
@Component({
  selector: 'workspace',
  templateUrl: './workspace.component.html',
  styleUrls: ['./workspace.component.css']
})
export class WorkspaceComponent implements OnInit {

  author_name: string;
  showMyWorkSpace = false;
  showAllStory = true;
  showMy = false;
  showMyDashboard = false;
  showNotificationList = false;
  showMyDashboardTab = false;
  domainConfig = {};
  constructor(
    private sharedService: SharedDataService,
    private restService: RestDataService,
    private config: Config,
    private localstorageService:LocalstorageService
  ) { }

  ngOnInit() {
    if (localStorage.getItem(StaticDataService.tokenLiteral)) {
      const token = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral));
      const newUserName = token.user.username;
      const oldUserName = token.user.oldUsername;
      this.author_name = newUserName + (oldUserName ? (';' + oldUserName) : '');
    }
    this.domainConfig = this.sharedService.currentDomainConfiguration;
    this.showMyDashboardTab = this.domainConfig['config']['editorFollow'] && this.domainConfig['config']['editorFollow']['my-dashboard'];
    this.sharedService.setTitle('Dashboard');
    this.setSuggestionMetaList()
  }

  //for suggestions api data
  setSuggestionMetaList(){
      this.localstorageService.setSuggestionData()
  }
    
   
}
